export const types = <const>{
	mutations: {
		VOZIDLO_RIDIC_MAPPER: 'VOZIDLO_RIDIC_MAPPER',
		COMPUTE_ROWS_HASH: 'COMPUTE_ROWS_HASH',
	},
	actions: {
		ROZSIRENI_ZAK_LIST: 'rozsireniZakList',
		TISK_ZAK_LIST: 'tiskZakList',
		GET_RPZV_LOG: 'getRpzvLog',
	},
};
